import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ClinicForm } from '@models/forms/clinic-form';
import { FormType } from '@models/forms/form-type.enum';
import { SharedForm } from '@models/forms/shared-form';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SharedFormService {
  sharedFormsLoaded = new Subject<SharedForm[]>();
  sharedFormSelected = new Subject<SharedForm>();
  sharedFormAdded = new Subject<SharedForm>();
  sharedFormAddedFromLibrary = new Subject<ClinicForm>();

  defaultId = 0;
  constructor(private http: HttpClient) {}

  addSharedForm(form: ClinicForm) {
    return this.http.post<SharedForm>(environment.baseUrl + 'api/SharedForms', form).pipe(
      map((addedSharedForm: SharedForm) => {
        this.sharedFormAdded.next(addedSharedForm);
        return addedSharedForm;
      })
    );
  }

  updateSharedForm(form: SharedForm): Observable<SharedForm> {
    return this.http.put<SharedForm>(environment.baseUrl + 'api/SharedForms', form);
  }

  getSharedFormById(id: number): Observable<SharedForm> {
    return this.http.get<SharedForm>(environment.baseUrl + 'api/SharedForms/' + id);
  }

  getSharedFormsByFormType(formType: FormType): Observable<SharedForm[]> {
    return this.http.get<SharedForm[]>(environment.baseUrl + 'api/SharedForms/ByFormType/' + formType);
  }

  deleteSharedForm(id: number): Observable<void> {
    return this.http.delete<void>(environment.baseUrl + 'api/SharedForms/' + id);
  }

  getFormsByServiceTemplateType(serviceTemplateTypeId: number): Observable<ClinicForm[]> {
    return this.http.get<ClinicForm[]>(
      environment.baseUrl + 'api/SharedForms/ByServiceTemplateType/' + serviceTemplateTypeId
    );
  }

  addFromLibrary(sharedFormId: number) {
    return this.http.post<ClinicForm>(environment.baseUrl + 'api/SharedForms/AddFromLibrary/' + sharedFormId, null).pipe(
      map((addedForm) => {
        this.sharedFormAddedFromLibrary.next(addedForm);
        return addedForm;
      })
    );
  }
}
